import { render } from "./Consultant.vue?vue&type=template&id=788f3107"
import script from "./Consultant.vue?vue&type=script&lang=js"
export * from "./Consultant.vue?vue&type=script&lang=js"
script.render = render

export default script